// Detects gallery item type from URL string
export function parseGalleryItem(url) {
  if (!url) return { type: "image", src: "" };
  const trimmed = String(url).trim();

  // Vimeo — supports vimeo.com/123, player.vimeo.com/video/123, and unlisted vimeo.com/123/abc
  const vimeoMatch = trimmed.match(
    /(?:vimeo\.com\/(?:video\/|channels\/[^/]+\/|groups\/[^/]+\/videos\/)?|player\.vimeo\.com\/video\/)(\d+)(?:\/([a-zA-Z0-9]+))?/
  );
  if (vimeoMatch) {
    const id = vimeoMatch[1];
    const hash = vimeoMatch[2];
    const params = new URLSearchParams({
      autoplay: "1",
      muted: "1",
      loop: "1",
      title: "0",
      byline: "0",
      portrait: "0",
    });
    if (hash) params.set("h", hash);
    return {
      type: "vimeo",
      src: trimmed,
      embedUrl: `https://player.vimeo.com/video/${id}?${params.toString()}`,
      thumbUrl: `https://vumbnail.com/${id}.jpg`,
    };
  }

  // YouTube — supports watch?v=X, youtu.be/X, /shorts/X
  const ytMatch = trimmed.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{6,})/
  );
  if (ytMatch) {
    const id = ytMatch[1];
    return {
      type: "youtube",
      src: trimmed,
      embedUrl: `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&modestbranding=1&rel=0`,
      thumbUrl: `https://img.youtube.com/vi/${id}/hqdefault.jpg`,
    };
  }

  // Direct video file
  if (/\.(mp4|webm|mov)(\?|$)/i.test(trimmed)) {
    return { type: "video", src: trimmed };
  }

  // Fallback: image
  return { type: "image", src: trimmed };
}
